import type {
  DailyEntryDay,
  DailyEntryOptions,
  DailyEntryRowInput,
  SaveDailyEntryInput,
  SubmitDailyEntryInput,
  SubmitDailyEntryResponse,
} from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchDailyEntryOptions(siteId: string, date: string) {
  const qs = new URLSearchParams({ siteId, date });
  return apiFetch<{ data: DailyEntryOptions }>(`/api/daily-entry/options?${qs}`);
}

export async function fetchDailyEntryDay(siteId: string, date: string) {
  const qs = new URLSearchParams({ siteId, date });
  return apiFetch<{ data: DailyEntryDay }>(`/api/daily-entry/day?${qs}`);
}

export async function copyPreviousDailyEntry(siteId: string, date: string) {
  const qs = new URLSearchParams({ siteId, date });
  return apiFetch<{ data: DailyEntryRowInput[] }>(`/api/daily-entry/copy-previous?${qs}`);
}

export async function searchDailyEntryWorkers(params: {
  siteId: string;
  page?: number;
  pageSize?: number;
  q?: string;
  crew?: string;
  excludeWorkerIds?: string[];
}) {
  const search = new URLSearchParams({ siteId: params.siteId });
  if (params.page) search.set("page", String(params.page));
  if (params.pageSize) search.set("pageSize", String(params.pageSize));
  if (params.q) search.set("q", params.q);
  if (params.crew) search.set("crew", params.crew);
  if (params.excludeWorkerIds?.length) {
    search.set("excludeWorkerIds", params.excludeWorkerIds.join(","));
  }
  return apiFetch<{
    data: DailyEntryOptions["workers"];
    meta: { total?: number; page: number; pageSize: number };
  }>(`/api/daily-entry/workers/search?${search}`);
}

export async function saveDailyEntryDraft(input: SaveDailyEntryInput) {
  return apiFetch<{ data: DailyEntryDay }>("/api/daily-entry/draft", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function submitDailyEntry(input: SubmitDailyEntryInput) {
  return apiFetch<{ data: SubmitDailyEntryResponse }>("/api/daily-entry/submit", {
    method: "POST",
    body: JSON.stringify(input),
  });
}
